import * as React from "react";
import Csrf from "../commons/model/Csrf";
import CsrfInput from "./CsrfInput";

interface LoginProps {
  showResetPasswordSuccessPanel: boolean;
  thisRegionLabel: string;
  isMultiRegions: boolean;
  errorMessages: string[];
  loginUsernameError: boolean;
  loginPasswordError: boolean;
  onPasswordReset: () => void;
  csrf: Csrf;
  technicalError?: boolean;
}

interface LoginState {
  showErrorPanel: boolean;
  showEmailError: boolean;
  showPasswordError: boolean;
}

export default class Login extends React.Component<LoginProps, LoginState> {
  constructor(props: LoginProps) {
    super(props);
    this.state = {
      showErrorPanel: this.props.errorMessages.length > 0 || !!this.props.technicalError,
      showEmailError: this.props.loginUsernameError,
      showPasswordError: this.props.loginPasswordError,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  private handleClick() {
    this.setState({ showErrorPanel: false, showPasswordError: false });
  }

  private onPasswordResetClick() {
    this.setState({
      showErrorPanel: false,
      showEmailError: false,
      showPasswordError: false,
    });
    this.props.onPasswordReset();
  }

  render() {
    const passwordUpdatedPanel = (
      <div className="alert-success">{i18n["Page.Login.Message.PasswordUpdated"]}</div>
    );

    const errorMessages =
      this.props.technicalError === true ? (
        <span>{i18n["Global.TechnicalError"]}</span>
      ) : (
        this.props.errorMessages.map((message) => <li key={message}>{i18n[message]}</li>)
      );

    const errorPanel = <div className="alert-error">{errorMessages}</div>;

    const emailErrorLabel = this.state.showEmailError ? (
      <div className="error-message" id="error-for-login-email">
        {i18n["Page.Login.Error.MissingUsername"]}
      </div>
    ) : null;
    const passwordErrorLabel = this.state.showPasswordError ? (
      <div className="error-message" id="error-for-password-error">
        {i18n["Page.Login.Error.MissingPassword"]}
      </div>
    ) : null;
    return (
      <form method="post" className="react-form">
        <CsrfInput csrf={this.props.csrf} />
        {this.props.isMultiRegions ? (
          <div className="input-group" id="change-region">
            {this.props.thisRegionLabel}
            <a className="link" href="/select-region">
              {i18n["Page.Login.ChangeRegion"]}
            </a>
          </div>
        ) : null}
        <div className="title-bar">
          <h1 className="title">{i18n["Page.Login.Title"]}</h1>
        </div>

        {(this.props.showResetPasswordSuccessPanel || this.state.showErrorPanel) && (
          <div className="input-group">
            {this.props.showResetPasswordSuccessPanel ? passwordUpdatedPanel : null}
            {this.state.showErrorPanel ? errorPanel : null}
          </div>
        )}

        <div className={"input-group" + (this.state.showEmailError ? " invalid" : "")}>
          <label htmlFor="login-email">{i18n["Global.EmailAddress"]}</label>
          <input
            id="login-email"
            name="username"
            type="text"
            className={this.state.showEmailError ? "invalid" : ""}
            placeholder={i18n["Global.EmailAddressPrompt"]}
            autoFocus
          />
          {emailErrorLabel}
        </div>

        <div className={"input-group" + (this.state.showPasswordError ? " invalid" : "")}>
          <label htmlFor="login-password">{i18n["Global.Password"]}</label>
          <input
            id="login-password"
            name="password"
            type="password"
            className={this.state.showPasswordError ? "invalid" : ""}
            placeholder={i18n["Global.PasswordPrompt"]}
          />
          {passwordErrorLabel}
        </div>
        <a
          id="forgot-password-link"
          className="link"
          style={{ alignSelf: "flex-end" }}
          onClick={() => this.onPasswordResetClick()}
        >
          {i18n["Page.Login.ForgotPassword"]}
        </a>
        <div className="input-group">
          <input id="remember-me" name="remember-me" type="checkbox" />
          <label htmlFor="remember-me">{i18n["Page.Login.RememberMe"]}</label>
        </div>
        <div className="action-container">
          <input
            type="submit"
            className="button-primary"
            value={i18n["Page.Login.Submit"]}
            onClick={this.handleClick}
          />
        </div>
      </form>
    );
  }
}
